import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '../../utils';
/**
 * @param minWidth each grid item will have a minimum width and share the rest of the space. The Breakpoint is also the minWidth. Default value is 375px (theme.spacing)
 * @param columnGap default value is 3 (theme.spacing)
 * @param rowGap default value is 3 (theme.spacing)
 */
export function FormGrid({ children, className, responsiveLayout, ...props }) {
    return (_jsx(FormGridRoot, { ...props, className: className, responsiveLayout: responsiveLayout, children: children }));
}
const FormGridRoot = styled('div', {
    shouldForwardProp: (prop) => ![
        'minWidth',
        'columnGap',
        'rowGap',
        'fill',
        'responsiveLayout',
    ].includes(prop),
    name: 'FormGridRoot',
})(({ theme, minWidth, columnGap, rowGap, fill, responsiveLayout }) => ({
    display: 'grid',
    gridTemplateColumns: minWidth
        ? `repeat(${fill ?? 'auto-fit'}, minmax(min(${minWidth}, 100%), 1fr))`
        : '',
    gridColumnGap: columnGap ? theme.spacing(columnGap) : '',
    gridRowGap: rowGap ? theme.spacing(rowGap) : '',
    ...(responsiveLayout && {
        gridColumnGap: theme.spacing(3),
        gridRowGap: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            gridColumnGap: theme.spacing(2),
            gridRowGap: theme.spacing(2),
        },
    }),
}));
